import { EnvKey } from "@ruminati/types/env";

export function getEnvFromUrl (): EnvKey {
  const hostname = window.location.hostname
  if (hostname.indexOf('localhost') > -1) return 'local'
  if (hostname.indexOf('-dev') > -1) return 'dev'
  if (hostname.indexOf('-staging') > -1) return 'staging'
  return 'prod'
}
